import { nonEmptyString } from '../../lib/format';
import React, { useId } from 'react';

interface ControlProps extends React.AriaAttributes { id?: string; required?: boolean | undefined }
export interface FieldProps {
  label?: React.ReactNode; htmlFor?: string; required?: boolean | undefined; optional?: boolean;
  helperText?: React.ReactNode; error?: React.ReactNode; children: React.ReactElement<ControlProps>; className?: string;
}
export function Field({ label, htmlFor, required, optional, helperText, error, children, className = '' }: FieldProps): React.JSX.Element {
  const generatedId = useId();
  const id = htmlFor ?? children.props.id ?? generatedId;
  const description = error ? `${id}-error` : helperText ? `${id}-helper` : undefined;
  const describedBy = (nonEmptyString([children.props['aria-describedby'], description].filter(Boolean).join(' ')) ?? undefined);
  return <div className={`lattice-field ${className}`.trim()}>
    {label && <label htmlFor={id} className="lattice-field__label">{label}
      {required && <span className="lattice-field__required" aria-hidden="true">*</span>}
      {optional && <span className="lattice-field__optional">(optional)</span>}
    </label>}
    {React.cloneElement(children, { id, required: required ?? children.props.required, 'aria-invalid': error ? true : children.props['aria-invalid'], 'aria-describedby': describedBy })}
    {error ? <span id={description} role="alert" className="lattice-field__error">{error}</span> : helperText ? <span id={description} className="lattice-field__helper">{helperText}</span> : null}
  </div>;
}

